<template>
    <!-- <div v-if="loading" class="loading-container">
        <Lottie :options="defaultOptions" :height="400" :width="400" />
    </div> -->
    <div class="vs-outer-container-xl">
        <select-service
            current-service="VS"
            :media-details="orderMediaDetailsVS"
            @add-next-service="selectNextService"
        />
        <div class="vs-content-outer-container-xl">
            <div class="vs-content-image-box-xl">
                <selected-image-box
                    :loading="savingService"
                    service-title="Virtual Staging"
                    :selected-img-src="selectedImgSrc"
                    :save-button-text="saveButtonTextVS"
                    :service-price="parseFloat(vsStore.stylesPrice)"
                    @project-overview-event="navigateToProjectSummary"
                    @apply-event="saveChangesButton"
                />

                <!-- <BeforeCommentBoxXl
                    :order-media-details="orderMediaDetailsVS"
                    :comments="VSComments"
                    :service-price="vsMode === 'style' ? vsStore.stylesPrice : advancePric"
                    @new-comment="addToVScomments"
                    @delete-comment="deleteComment"
                    @edit-comment="editComment"
                /> -->
            </div>
            <!-- <div class="vs-content-change-mode-xl">
                <select-mode />
            </div> -->
            <div class="vs-content-select-catalogues-xl">
                <div v-if="vsMode === 'style'">
                    <room-type />
                    <style-catalogues />
                </div>
                <div v-else>
                    <advance-mode />
                </div>
            </div>

            <comment-box-xl
                class="vs-right-side-comment-box-xl"
                :comments="VSComments"
                :reference-photo="VSReferencePhoto"
                service="VS"
                :has-reference-photo="true"
                @service-description-event="addComment"
            />
        </div>

        <!-- <div class="vs-select-service-container-xl">
            <div class="vs-right-side-buttons-container-xl">
                <button class="vs-right-side-buttons-next-xl" @click="goToSummary">
                    Project Overview
                </button>
                <button
                    class="vs-right-side-buttons-save-active-xl"
                    @click="saveChangesButton(saveButtonTextVS)"
                >
                    {{ saveButtonTextVS }}
                </button>
            </div>

            <div class="vs-right-side-container-xl mt-4">
                <div class="vs-right-side-output-xl">
                    <p class="primary-color fw-bold text-center">Output</p>
                    <style-mode-output v-if="vsMode === 'style'" />
                    <advance-mode-output v-else />
                </div>
            </div>
        </div> -->

        <!-- Modals -->

        <modal name="go-to-project-summary" height="auto" width="560" :styles="modalStyle">
            <go-to-project-summary
                @navigate-project-summary="$router.push('/project-overview')"
                @save-navigate-project-summary="saveNavigateProjectSummary"
            />
        </modal>

        <modal name="save-service" height="auto" width="558px" :styles="modalStyle">
            <save-service current-service="VS" :order-media-details="orderMediaDetailsVS" />
        </modal>
        <modal name="reminding-add-service" height="auto" width="560" :styles="modalStyle">
            <reminding-add-service @navigate-between-services="changeService" />
        </modal>
        <modal name="add-service-warning" height="auto" width="560" :styles="modalStyle">
            <add-service-warning />
        </modal>

        <div class="notification-container-xl">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import Lottie from 'vue-lottie';
import animationData from '@/assets/new-loading.json';
import baseApiAddress from '@/axios.config';
import saveService from '@/components/modals/save-service.vue';
import SelectService from '@/components/select-service/SelectService.vue';
import CommentBoxXl from '@/components/comment-box/components/CommentBoxXl.vue';
// import SelectMode from '../components/SelectMode.vue';
// import BeforeCommentBoxXl from '@/components/before-comment-box/components/BeforeCommentBoxXl.vue';
import RoomType from '../components/RoomType.vue';
import StyleCatalogues from '../components/StyleCatalogues.vue';
// import StyleModeOutput from '../components/StyleModeOutput.vue';
import AdvanceMode from '../components/AdvanceMode.vue';
// import AdvanceModeOutput from '../components/AdvanceModeOutput.vue';
import RemindingAddService from '@/components/modals/reminding-add-service.vue';
import AddServiceWarning from '@/components/modals/add-service-warning.vue';
import GoToProjectSummary from '@/components/modals/GoToProjectSummary.vue';
import SelectedImageBox from '../../components/SelectedImageBox.vue';
import virtualStagingMixin from '../mixins/virtualStagingMixin';
import Notification from '@/components/snacks/index.vue';

export default {
    components: {
        Notification,
        SelectService,
        CommentBoxXl,
        // SelectMode,
        // BeforeCommentBoxXl,
        SelectedImageBox,
        RoomType,
        StyleCatalogues,
        // StyleModeOutput,
        AdvanceMode,
        // AdvanceModeOutput,
        saveService,
        RemindingAddService,
        AddServiceWarning,
        GoToProjectSummary,
        // Lottie,
    },
    mixins: [virtualStagingMixin],
    data() {
        return {
            modalStyle: {
                borderRadius: '24px',
                boxShadow: '0px 4px 13px rgba(0, 0, 0, 0.15)',
            },
            saveChangeButtonText: 'Save Change',
            defaultOptions: { animationData },
        };
    },

    methods: {
        async saveChangesGoToNextService() {
            try {
                const { status } = await baseApiAddress({
                    method: 'post',
                    url: '/orders/new-order/add-service',
                    data: this.serviceData,
                });
                if (status >= 200 && status < 300) {
                    this.$store.commit('setReferencePhotoVS', 'reset reference');
                    this.cancelGoToNextService();
                }
            } catch (error) {}
        },
        cancelGoToNextService() {
            const { _id } = this.orderMediaDetailsVS;
            switch (this.nextServiceTitle) {
                case 'ie':
                    this.$router.push(`/image-enhancement/image_id=${_id}`);
                    break;
                case 'ir':
                    this.$router.push(`/item-removal/image_id=${_id}`);
                    break;
                case 'vs':
                    this.$router.push(`/virtual-staging/image_id=${_id}`);
                    break;
                default:
                    break;
            }
        },

        //It is used when the user wants to change the survey
        changeService(type) {
            if (type === 'cancel') {
                this.changeRoute('change-service');
                return;
            }
            this.saveVsServiceChanges('change-service');
        },
        selectNextService(type) {
            this.nextServiceTitle = type;
            if (this.vsHasChanged) {
                this.$modal.show('reminding-add-service');
                return;
            }
            this.changeRoute('change-service');
        },
        changeRoute(type) {
            if (type === 'project-summary') {
                return this.$router.push('/project-overview');
            }
            if (type === 'change-service') {
                this.$router.push(
                    `/${this.nextServiceTitle}/image_id=${this.orderMediaDetailsVS._id}`
                );
            }
        },
        async saveService() {
            try {
                const { status, data } = await baseApiAddress({
                    method: 'post',
                    url: '/orders/new-order/add-service',
                    data: this.serviceData,
                });
                if (status >= 200 && status < 300) {
                    this.saveChangeButtonText = 'Next Photo';
                    this.$store.commit('setReferencePhotoVS', 'reset reference');
                    this.$store.commit('checkCommentsChangesVS', false);
                    this.$store.commit('checkRefPhotoVS', false);
                    this.$store.commit('checkSelectedStyleChanges', false);
                    this.$store.commit('checkRoomTypeChanges', false);
                    this.$store.commit('checkMultiChanges', false);
                    this.$store.commit('checkSingleChanges', false);

                    const showModalLocalStorage = localStorage.getItem('show-save-service-modal');
                    if (showModalLocalStorage !== null) {
                        if (showModalLocalStorage === 'show') {
                            return this.$modal.show('save-service');
                        }
                    } else {
                        return this.$modal.show('save-service');
                    }
                }
            } catch (error) {}
        },
        cancelGoToNextPhoto() {
            this.$router.push('/project-overview');
        },
        async saveChangesGoToNextPhoto() {
            try {
                const {
                    VSComments,
                    selectedRoomType,
                    selectedStyles,
                    singleCatalogues,
                    multiCatalogues,
                } = this.virtualStagingStore;
                let single = [],
                    multiple = [],
                    vsServices = [],
                    styles = [],
                    roomTypesId = [];

                selectedRoomType.map((item) => {
                    roomTypesId.push(item.id);
                });
                selectedStyles.map((item) => {
                    styles.push({
                        output: item.numOfOutput,
                        VS_Type: 'style',
                        style_id: item.id,
                        roomTypes: roomTypesId,
                    });
                });
                singleCatalogues.map((item) => {
                    single.push({
                        output: 1,
                        VS_Type: 'single',
                        catalogs: [item.id],
                    });
                });
                for (let i = 0; i < multiCatalogues.length; i++) {
                    let cataloguesArray = [];
                    multiCatalogues[i].map((item) => {
                        cataloguesArray.push(item.id);
                    });
                    multiple.push({
                        output: 1,
                        VS_Type: 'multi',
                        catalogs: cataloguesArray,
                    });
                    cataloguesArray = [];
                }
                if (VSComments === 'style') {
                    styles.map((style) => {
                        vsServices.push(style);
                    });
                } else {
                    single.map((item) => {
                        vsServices.push(item);
                    });
                    multiple.map((item) => {
                        vsServices.push(item);
                    });
                }

                const serviceData = {
                    order_id: this.orderMediaDetailsVS.order_id,
                    media_details_id: this.orderMediaDetailsVS._id,
                    type: 'VS',
                    service_details: {
                        comments: this.VSComments,
                        references: this.VSReferencePhoto,
                    },
                    services: vsServices,
                };
                const { status, data } = await baseApiAddress({
                    method: 'post',
                    url: '/orders/new-order/add-service',
                    data: serviceData,
                });
                if (status >= 200 && status < 300) {
                    this.$store.commit('setReferencePhotoVS', 'reset reference');
                    this.$router.push('/project-overview');
                }
            } catch (error) {}
        },
        goToSummary() {
            if (this.vsHasChanged) {
                this.$modal.show('go-to-project-summary');
                return;
            }
            this.$router.push('/project-overview');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/Virtual-StagingXl';
.loading {
    &-container {
        @include centerByFlex;
        position: fixed;
        inset: 0;
        background-color: rgba($color: #f5f5f5, $alpha: 1);
        z-index: 1000;
    }
}

.notification {
    &-container-xl {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 10;
    }
}
</style>
